import {
  listUsersByGroup,
  manageUsers as manageUsersQuery,
} from "../graphql/queries";
import { API, graphqlOperation, Auth } from "aws-amplify";
import {
  FETCHING_MULTIPLE_USERS,
  LOADED_MULTIPLE_USERS,
  SAVE_USER_ERROR,
  CREATE_ACCOUNT_INFORMATION,
  ADD_USER_TO_GROUP_SUCCESS,
} from "./ActionTypes";

export const parseUserObject = (users) => {
  let usersArray = [];
  for (let item of users) {
    let user = { userName: item.Username };
    for (let attribute of item.Attributes) {
      if (attribute.Name === "given_name") {
        user.firstName = attribute.Value;
      }
      if (attribute.Name === "family_name") {
        user.lastName = attribute.Value;
      }
      if (attribute.Name === "email") {
        user.email = attribute.Value;
      }
    }
    usersArray.push(user);
  }
  return usersArray;
};

/**
 * Returns a list of user by group_name
 */
export const listUsers = (groupName) => async (dispatch) => {
  dispatch({ type: FETCHING_MULTIPLE_USERS });
  try {
    const users = await API.graphql(
      graphqlOperation(listUsersByGroup, { groupName }),
      []
    );

    let list = JSON.parse(users.data.listUsersByGroup).body.Users;
    const result = parseUserObject(list);

    dispatch({
      type: LOADED_MULTIPLE_USERS,
      payload: result,
    });
  } catch (err) {
    console.log("error listUsers", err);
  }
};

export const saveUser = (params) => async (dispatch) => {
  try {
    const {
      data: { manageUsers },
    } = await API.graphql(graphqlOperation(manageUsersQuery, params), []);

    /**
     * The type of "manageUsers" return one of type: "string" or "object"
     * => checking type then get the return `Users`.
     *
     */
    if (manageUsers) {
      let usersPayload = null;

      if (typeof manageUsers === "object") {
        usersPayload = manageUsers.Users || null;
      }

      if (typeof manageUsers === "string") {
        try {
          // Parse to json-object if type is "string"
          const parse = JSON.parse(manageUsers);
          usersPayload = parse.Users || null;
        } catch (e) {
          throw new Error("Parse users error");
        }
      }

      if (usersPayload) {
        const payload = parseUserObject(usersPayload);
        dispatch({ type: LOADED_MULTIPLE_USERS, payload });
        return;
      }
    }

    dispatch({ type: SAVE_USER_ERROR });
  } catch (err) {
    // For debugging purpose
    console.log("Error in saving user:", err);

    const message = err.errors ? err.errors[0]?.message : err.message;
    throw new Error(message);
  }
};

/**
 * Returns groups that user is assigned to
 */
export const getUserGroups = async () => {
  try {
    const { accessToken } = await Auth.currentSession();
    const cognitoGroups = accessToken.payload["cognito:groups"];
    return cognitoGroups;
  } catch (e) {
    throw e;
  }
};

/**
 * Replace '_' for space
 * To be use for groupName, cognito groups don't support spaces
 */
export const formatName = (name) => {
  if (!name) return;
  else return name.split("_").join(" ");
};

export const createAccountInformation = (params) => (dispatch) =>
  dispatch({ type: CREATE_ACCOUNT_INFORMATION, payload: params });

export const addNewUserToGroup = (params) => async (dispatch) => {
  try {
    const {
      data: { manageUsers },
    } = await API.graphql(graphqlOperation(manageUsersQuery, params), []);

    if (manageUsers) {
      dispatch({ type: ADD_USER_TO_GROUP_SUCCESS });
    }
  } catch (err) {
    // For debugging purpose
    console.log("Error in adding user to group:", err);

    const message = err.errors ? err.errors[0]?.message : err.message;
    throw new Error(message);
  }
};
